/*!
 * Common
 * 프로젝트 전체 플러그인의 초기화 및 재정의
 */

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
window.tooltip = bootstrap.tooltip;
import 'overlayscrollbars/overlayscrollbars.css';
import {OverlayScrollbars} from 'overlayscrollbars';

export default class Common {
  get options() {
    return {};
  }

  constructor(options = {}) {
    this.settings = Object.assign(this.options, options);
    this._init();
  }

  _init() {
    this.scrollbar;
    this._initTooltips();
    this._initScrolls();
  }

  // Bootstrap tooltips
  _initTooltips() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl, {
        delay: {show: 200, hide: 0},
      });
    });

    var tooltipTriggerListNoDelay = [].slice.call(
      document.querySelectorAll('.no-delay[data-bs-toggle="tooltip"][data-bs-delay="0"]'),
    );
    var tooltipListNoDelay = tooltipTriggerListNoDelay.map(function (tooltipTriggerElNoDelay) {
      return new bootstrap.Tooltip(tooltipTriggerElNoDelay, {
        delay: {show: 0, hide: 0},
      });
    });
  }

  _initScrolls() {
    if (typeof OverlayScrollbars !== 'undefined') {
      const os = OverlayScrollbars(document.body, {
        scrollbars: {
          autoHide: 'leave',
          autoHideDelay: 600,
          theme: this._setCustomTheme(),
        },
      });
      window.os = os;
      document.querySelectorAll('.scrollable').forEach((div) => {
        OverlayScrollbars(div, {
          scrollbars: {autoHide: 'leave', autoHideDelay: 600, theme: this._setCustomTheme()},
          overflowBehavior: {x: 'scroll', y: 'scroll'},
        });
      });
      document.querySelectorAll('.table-responsive.table-scrollable').forEach((div) => {
        OverlayScrollbars(div, {
          scrollbars: {theme: this._setCustomTheme()},
          overflowBehavior: {x: 'scroll', y: 'hidden'},
        });
      });
    }
  }

  _destroyScrollbar() {
    if (this.scrollbar) {
      this.scrollbar.destroy();
      this.scrollbar = null;
    }
  }

  _setCustomTheme() {
    if (document.querySelector('[data-bs-theme]')) {
      const selectedTheme = document.querySelector('[data-bs-theme]').value;
      const theme = selectedTheme === 'dark' ? 'os-theme-dark' : 'os-theme-light';
      return theme;
    } else {
      return 'os-theme-dark';
    }
  }
}
